import { Factory, Truck, Building } from 'lucide-react';
import type { Product } from './types';

export const manufacturingProducts: Product[] = [
  {
    id: 'manufacturing-management',
    title: 'Manufacturing Management System',
    subtitle: 'Complete manufacturing operations platform',
    description: 'Comprehensive manufacturing management with production planning, quality control, inventory management, and supply chain optimisation designed for UK manufacturing standards and regulations.',
    icon: Factory,
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    businessTypes: ['#manufacturing', '#industrial', '#production', '#quality-control', '#supply-chain'],
    features: [
      'Production Planning & Scheduling with UK Manufacturing Standards',
      'Quality Control & Assurance (ISO 9001 & UK Compliance)',
      'Inventory Management & Tracking with UK Warehouse Regulations',
      'Supply Chain Optimisation for UK & European Markets',
      'Equipment Maintenance Management with HSE Compliance',
      'Workforce Management',
      'Cost Analysis & Reporting',
      'Compliance & Safety Management'
    ],
    pricing: { setup: 55000, monthly: 2530 },
    color: 'from-gray-500 to-slate-600'
  },
  {
    id: 'logistics-transportation',
    title: 'Logistics & Transportation Management',
    subtitle: 'Complete logistics operations platform',
    description: 'End-to-end logistics management with fleet tracking, route optimisation, delivery management, and supply chain visibility for UK and European operations.',
    icon: Truck,
    image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    businessTypes: ['#logistics', '#transportation', '#delivery', '#fleet-management', '#supply-chain'],
    features: [
      'Fleet Management & GPS Tracking with UK Traffic Regulations',
      'Route Optimisation & Planning for UK Road Networks',
      'Delivery Management & Scheduling with UK Postal Integration',
      'Warehouse Management Integration with UK Standards',
      'Driver Management & Performance with UK Licensing Requirements',
      'Fuel Management & Cost Control',
      'Customer Communication & Updates',
      'Analytics & Reporting Dashboard'
    ],
    pricing: { setup: 48000, monthly: 2208 },
    color: 'from-blue-500 to-cyan-600'
  },
  {
    id: 'construction-project-management',
    title: 'Construction Project Management System',
    subtitle: 'Complete construction oversight',
    description: 'Comprehensive construction management with project planning, resource allocation, safety compliance, and progress tracking.',
    icon: Building,
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Manufacturing & Industrial',
    status: 'Available',
    businessTypes: ['#construction', '#project-management', '#building', '#infrastructure', '#safety'],
    features: [
      'Project Planning & Scheduling',
      'Resource Allocation & Management',
      'Safety Compliance & Monitoring',
      'Progress Tracking & Reporting',
      'Budget Management & Cost Control',
      'Document Management & Collaboration',
      'Equipment Tracking & Maintenance',
      'Quality Assurance & Inspections',
      'Subcontractor Management',
      'Mobile Field Access',
      'Risk Management & Mitigation',
      'Regulatory Compliance Tracking'
    ],
    pricing: { setup: 52000, monthly: 2392 },
    color: 'from-orange-500 to-amber-600'
  }
];
